/* eslint-disable react/require-default-props */
import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { bool, func, string, shape } = proptypes;

/**
 * Reusable alert message component for bundle-related notifications
 * @param {Object} props
 * @param {string} props.status - Alert status: 'success' | 'warning' | 'error' | 'info'
 * @param {string} props.size - Alert size: 'small' | 'large'
 * @param {string} props.headline - Optional alert headline
 * @param {Object} props.content - Alert content configuration
 * @param {string} props.content.main - Main message text (can be bold)
 * @param {string} props.content.secondary - Secondary message text
 * @param {Object} props.link - Link configuration
 * @param {boolean} props.link.show - Whether to show link
 * @param {string} props.link.text - Link text
 * @param {Function} props.link.onClick - Link click handler
 * @param {boolean} props.link.newLine - Show link on new line
 * @param {Function} props.onClose - Close handler
 */
const BundleAlertmessage = ({
  status = 'success',
  size = 'small',
  headline = null,
  content = {},
  link = {
    show: false,
    text: '',
    onClick: () => {},
    newLine: false
  },
  onClose = null
}) => {
  const { main, secondary } = content || {};
  const { show: showLink, text: linkText, onClick: onLinkClick, newLine: linkOnNewLine } = link || {};

  return (
    <div data-testid="BundleAlertmessage">
      <Alert
        status={status}
        size={size}
        headline={headline}
        onClose={onClose}
      >
        <div
          className={`sui-flex ${linkOnNewLine ? 'sui-flex-col sui-items-start' : 'sui-flex-row sui-items-baseline'}`}
        >
          <Typography variant="body-sm" height="tight">
            {main && !secondary ? (
              main
            ) : (
              <>
                {main && (
                  <Typography variant="body-sm" weight="bold" height="tight" component="span">
                    {main}
                  </Typography>
                )}
                {secondary && (
                  <>
                    {main && '\u00A0'}
                    {secondary}
                  </>
                )}
              </>
            )}
          </Typography>

          {showLink && (
            <>
              {!linkOnNewLine && '\u00A0'}
              <Link
                variant="body-xs"
                height="tight"
                component="button"
                onClick={onLinkClick}
              >
                {linkText}
              </Link>
            </>
          )}
        </div>
      </Alert>
    </div>
  );
};

BundleAlertmessage.propTypes = {
  status: string,
  size: string,
  headline: string,
  content: shape({
    main: string,
    secondary: string
  }),
  link: shape({
    show: bool,
    text: string,
    onClick: func,
    newLine: bool
  }),
  onClose: func
};

BundleAlertmessage.displayName = 'BundleAlertmessage';

export { BundleAlertmessage };